import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_component_el_input, {
    ref: "input",
    modelValue: _ctx.displayValue,
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    max: _ctx.max,
    min: _ctx.min,
    onBlur: _ctx.handleBlur,
    onFocus: _ctx.handleFocus,
    onInput: _ctx.handleInput,
    onChange: _ctx.handleInputChange
  }, _createSlots({ _: 2 }, [
    (_ctx.$slots.prepend)
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "prepend")
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots.append)
      ? {
          name: "append",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "append")
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["modelValue", "placeholder", "disabled", "size", "max", "min", "onBlur", "onFocus", "onInput", "onChange"]))
}